<template lang="pug">
  v-container(fluid grid-list-lg)
    v-layout(row wrap) 
      v-flex(md4 xs12)
        v-layout(row wrap)
          v-flex
            DueDate(:service="service.commercial" minDay="5")
           
          v-flex(xs12)
            CommercialStatus
          v-flex(xs12)
            Status(serviceID="194" service="Commercial")
          v-flex(xs12)
            CommentList(:refID="location.storeID" :typeId="6")
      v-flex(md8 xs12)
        v-layout(row wrap)
          v-flex(xs12)
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.note') }}
                v-spacer
                v-btn(small v-if="checkRightStatus(35)" color='info' dark @click="updateNote()" icon)
                  v-icon(small) save
              v-card-text
                v-textarea(rows="8" v-model="service.commercial.note")  
          v-flex(xs12)
            CommercialList

</template>

<script>
import CommercialStatus from '../../AdImage/components/Status'
import CommercialList from '../../AdImage/components/Commercial/CommercialList'
import DueDate from './components/DueDate'
import CommentList from '../../Comment/components/List'
import Status from './Status'
import { mapGetters } from "vuex";
export default {
  components: {
    CommercialStatus,
    CommercialList,
    Status,
    CommentList,
    DueDate,
  },
  computed: {
    ...mapGetters("location", ["location", 'service']),
    ...mapGetters('global', ['currentUser', 'checkRightStatus']),
    dueDateCount() {
      return this.$moment(this.service.commercial.dueDate).diff(
        this.$moment().format("MM/DD/YYYY"),
        "day"
      );
    },
  },
  methods: {
    updateNote() {
      ReconcileService.update(this.service.commercial.storeID, 193, this.service.reconcile)
        .then(result => {
          this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: 'success',
            title: 'Reconcile Service is started'
          })
          this.$emit('updated')
        }).catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
</style>